import { render } from "./SearchSessionItem.vue?vue&type=template&id=23a53c97"
import script from "./SearchSessionItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchSessionItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchSessionItem.vue?vue&type=style&index=0&id=23a53c97&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__